"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionAndLocality = void 0;
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const PositionAndLocality = ({ details, ws, hasMaster, positions, }) => {
    const position = details
        ? positions.find((p) => p.id === details.positionId)
        : null;
    const locality = details?.localityId && ws && ws.localities
        ? ws.localities.find((l) => l.id === details.localityId)
        : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        position || hasMaster?.positionName ? (react_1.default.createElement("div", { className: 'ds-viewshift-row' },
            react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('POSITION')),
            react_1.default.createElement("div", { className: 'ds-viewshift-col-value' }, hasMaster?.positionName ? (react_1.default.createElement(_ui_1.Position, { lg: true, pos: {
                    name: hasMaster.positionName,
                    color: position?.color || '666666',
                } })) : (react_1.default.createElement(_ui_1.Position, { lg: true, pos: { color: undefined, ...position } }))))) : null,
        locality ? (react_1.default.createElement("div", { className: 'ds-viewshift-row' },
            react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('LOCALITY')),
            react_1.default.createElement("div", { className: 'ds-viewshift-col-value' },
                locality.shortName ? '(' + locality.shortName + ') ' : '',
                locality.name,
                locality.address && locality.address !== ''
                    ? ', ' + locality.address
                    : ''))) : null));
};
exports.PositionAndLocality = PositionAndLocality;
